import { AudioLines, Download } from "lucide-react";
import { fileUrl } from "@/constants/roles";

export const AudioPlayer = ({ path, filename, testid }) => (
  <div data-testid={testid} className="overflow-hidden rounded-2xl border border-[var(--pv-border)] bg-[var(--pv-card)]">
    <div className="flex items-center gap-3 px-4 py-3">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-cyan-500/15">
        <AudioLines className="h-4 w-4 text-cyan-400" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-xs font-semibold text-[var(--pv-text-2)]">{filename || "Audio"}</p>
        <audio
          data-testid={`${testid}-audio`}
          controls
          preload="metadata"
          src={fileUrl(path)}
          className="mt-1.5 h-8 w-full"
        />
      </div>
      <a
        data-testid={`${testid}-download`}
        href={fileUrl(path)}
        download={filename || true}
        className="flex shrink-0 items-center gap-1.5 rounded-full bg-[var(--pv-raised)] px-3 py-1.5 text-[11px] font-bold text-[var(--pv-text)] transition-colors hover:bg-[var(--pv-raised)]"
      >
        <Download className="h-3 w-3" /> Download
      </a>
    </div>
  </div>
);
